import _regeneratorRuntime from "/usr/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetcher from "@/common/axiosInstance";
import FetchSyarahv2 from "@/common/fetchSyarahv2";
import { ValidationException } from "@/common/exceptions/ValidationException";
export var api__updateCustomer = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(data) {
    var res;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return fetcher().post("customer/update-profile", data);
        case 2:
          res = _context.sent;
          console.log(res, 'update customer');
          return _context.abrupt("return", (res === null || res === void 0 ? void 0 : res.data) || null);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function api__updateCustomer(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var api__unsubscribeInterest = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(data) {
    var res;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return fetcher().post("customer/unsubscribe-interest", data);
        case 2:
          res = _context2.sent;
          return _context2.abrupt("return", res.data || null);
        case 4:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function api__unsubscribeInterest(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
export var api__loginOrSignup = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(phoneNumber) {
    var formData, res;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          formData = new FormData();
          formData.append("phone_number", phoneNumber);
          _context3.next = 4;
          return FetchSyarahv2({
            throwValidationException: true
          }).post("/auth/login-or-signup", formData);
        case 4:
          res = _context3.sent;
          return _context3.abrupt("return", res.data.data);
        case 6:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function api__loginOrSignup(_x3) {
    return _ref3.apply(this, arguments);
  };
}();
export var api__logoutUser = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return fetcher().post("/customer/logout")["catch"](function (err) {
            console.log("/customer/logout err", err);
            return null;
          });
        case 2:
          return _context4.abrupt("return", _context4.sent);
        case 3:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function api__logoutUser() {
    return _ref4.apply(this, arguments);
  };
}();
export var api__updateUserCityProfile = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(city) {
    var formData, res;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          formData = new FormData();
          formData.append("city_id", city);
          _context5.next = 4;
          return fetcher().post("customer/update-profile", formData);
        case 4:
          res = _context5.sent;
          return _context5.abrupt("return", res.data.data);
        case 6:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function api__updateUserCityProfile(_x4) {
    return _ref5.apply(this, arguments);
  };
}();
export var api__updateUserNameProfile = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(name) {
    var formData, res;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          formData = new FormData();
          formData.append("full_name", name);
          _context6.next = 4;
          return fetcher().post("customer/update-profile", formData);
        case 4:
          res = _context6.sent;
          return _context6.abrupt("return", res.data.data);
        case 6:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return function api__updateUserNameProfile(_x5) {
    return _ref6.apply(this, arguments);
  };
}();
export var api__updateUserMobileProfile = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(mobile) {
    var formData, res;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          formData = new FormData();
          formData.append("phone_number", mobile);
          formData.append("is_phone_number", true);
          _context7.next = 5;
          return fetcher().post("customer/update-profile", formData);
        case 5:
          res = _context7.sent;
          if (!res.data.errors) {
            _context7.next = 8;
            break;
          }
          throw ValidationException.factoryFromAxios(res);
        case 8:
          return _context7.abrupt("return", res.data.data);
        case 9:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return function api__updateUserMobileProfile(_x6) {
    return _ref7.apply(this, arguments);
  };
}();
export var api__togglePostToFavorite = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8(postId) {
    var _res$data, _res$data$data;
    var data, res;
    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          data = new FormData();
          data.append("post_id", postId);
          data.append("is_online", "1");
          _context8.next = 5;
          return fetcher().post("/customer/add-delete-favourite", data);
        case 5:
          res = _context8.sent;
          return _context8.abrupt("return", !!(res !== null && res !== void 0 && (_res$data = res.data) !== null && _res$data !== void 0 && (_res$data$data = _res$data.data) !== null && _res$data$data !== void 0 && _res$data$data.is_favorite));
        case 7:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return function api__togglePostToFavorite(_x7) {
    return _ref8.apply(this, arguments);
  };
}();